<template>
    <v-container >
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <h1 class="mb-3 heading deep-purple--text text--accent-3">Mazgāšanas</h1>
                </v-flex>

                <v-spacer></v-spacer>

                <v-flex xs10 sm4 >
                    <v-text-field
                            @input="searchCleanings"
                            v-model="search"
                            append-icon="search"
                            label="Meklēt"
                            single-line
                            color="deep-purple accent-3"
                            class="mb-2"
                    ></v-text-field>
                </v-flex>
                <v-flex v-if="!showForm" xs2 sm1 class="pt-2 text-xs-right">
                    <v-tooltip top>
                        <v-btn  @click="showAddCleaningForm" small outline fab color="deep-purple" slot="activator">
                            <v-icon >add</v-icon>
                        </v-btn>
                        <span>Pievienot mazgāšanu</span>
                    </v-tooltip>
                </v-flex>
                <v-flex v-if="showForm" xs2 sm1 class="pt-2 text-xs-right">
                        <v-btn  @click="hideAddCleaningForm" small outline fab color="deep-orange lighten-1" slot="activator">
                            <v-icon >block</v-icon>
                        </v-btn>

                </v-flex>

            </v-layout>

        <add-cleaning v-if="showForm"></add-cleaning>

        <template v-if="cleanings">
            <v-card flat v-for="cleaning in cleanings.data" :key="cleaning.id">
                <v-layout row wrap class="pa-3 mb-1">
                    <v-flex xs6 md2>
                        <div class="caption grey--text">Mazgāšanas datums</div>
                        <div>{{cleaning.cleaning_date}}</div>
                    </v-flex>
                    <v-flex xs6 md2>
                        <div class="caption grey--text">Tips</div>
                        <div>{{cleaning.cleaned_item.type}}</div>
                    </v-flex>
                    <v-flex xs6 md2>
                        <div v-if="cleaning.cleaned_item.type === 'Konteiners'" class="caption grey--text">Konteinera nr</div>
                        <div v-else class="caption grey--text">Cisternas nr</div>
                        <div>{{cleaning.cleaned_item.regNr}}</div>
                    </v-flex>
                    <v-flex xs6 md2>
                        <div class="caption grey--text">Klients</div>
                        <div>{{cleaning.customer.name}}</div>
                    </v-flex>
                    <v-flex xs6 md2>
                        <div class="caption grey--text">Krava</div>
                        <div>{{cleaning.cargo.name}}</div>
                    </v-flex>
                    <v-flex xs6 md1>
                            <div class="caption grey--text">Sert. nr</div>
                            <div v-if="cleaning.certificate">{{cleaning.certificate.certificate_nr}}</div>
                            <div v-else>N/A</div>
                    </v-flex>
                    <v-flex xx12 sm4 md1>
                        <v-layout row wrap>
                            <v-flex xs6>
                                <v-tooltip top>
                                    <v-btn icon :to="`/cleanings/${cleaning.id}`" flat small slot="activator">
                                        <v-icon color="grey">open_in_new</v-icon>
                                    </v-btn>
                                    <span>Skatīt mazgāšanu</span>
                                </v-tooltip>
                            </v-flex>
                            <v-flex xs6>
                                <v-tooltip top>
                                    <v-btn icon @click="deleteCleaning(cleaning.id)" flat small slot="activator">
                                        <v-icon color="grey">delete</v-icon>
                                    </v-btn>
                                    <span>Dzēst mazgāšanu</span>
                                </v-tooltip>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card>

            <v-layout row>
                <v-flex v-if="cleanings.meta.last_page > 1" sm6  offset-sm4>
                    <v-pagination
                            v-model="cleanings.meta.current_page"
                            :length="cleanings.meta.last_page"
                            :total-visible="5"
                            color="deep-purple accent-3"
                            @input="onPageChange"
                    ></v-pagination>
                </v-flex>
            </v-layout>
        </template>

        <v-snackbar
                v-model="snackbar"
                :color="color"
                :timeout="timeout"
                auto-height
                right
        >
            {{ text }}
            <v-btn dark
                   flat
                   @click="snackbar = false"
            >X</v-btn>
        </v-snackbar>

    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex'
    import AddCleaning from "../components/AddCleaning.vue";

    export default {
        name: "Cleanings",
        components: {AddCleaning},
        data: () => ({
            snackbar: false,
            color: '',
            timeout: 2000,
            text: '',
        }),
        mounted() {
            this.$store.dispatch('hideAddCleaningForm')
            this.$store.dispatch('resetSearch')
            this.$store.dispatch('getCleanings')
        },
        computed: {
            ...mapGetters({
                cleanings: 'cleanings',
                search: 'search',
                showForm: 'showAddCleaningForm'
            })
        },
        methods: {
            searchCleanings(value){
                this.$store.dispatch('changeSearch', value)
                this.$store.dispatch('getCleanings')
            },
            onPageChange() {
                this.$store.dispatch('getCleanings', this.cleanings.meta.current_page);
            },
            showAddCleaningForm(){
                this.$store.dispatch('showAddCleaningForm')
            },
            hideAddCleaningForm(){
                this.$store.dispatch('hideAddCleaningForm')
            },
            deleteCleaning(cleaningId){
                if(confirm('Vai esi drošs?')){
                    this.$Progress.start()
                    this.$store.dispatch('deleteCleaning', cleaningId)
                    this.snackbar = true
                    this.color = 'red'
                    this.text = 'Mazgāšana dzēsta'
                }
            },

        }
    }
</script>

<style scoped>

</style>